import React, {Component} from "react";
import { Link } from 'react-router-dom';

import "../App.css";

class Resources extends Component {
    style = {
        margin: 20,
        fontFamily: 'monospace',
        padding: 12
    };

    render() {
        return (
            <div className="content">
                <p>These are the images that you'll need when you're building some of the apps in the book. The
                    &nbsp;<Link to="source">source code</Link>&nbsp; already includes all of the images, but we put separate
                    copies of them here for when you're building the apps yourself.
                </p>

                <p>Each of these links are to zip-archives, which you need to decompress. Some images come in various
                    resolutions (such as &nbsp;<code>mdpi</code>, &nbsp;<code>xxxhdpi</code> and so on) and when you
                    unzip the images you'll find we've
                    put them into folders which have the same names as the locations they'll need to be placed
                    in your app. So if an images is in &nbsp;<code>drawable-mdpi</code>, you will need to place it in
                    &nbsp;<code>app/src/main/res/drawable-mdpi</code>.
                </p>

                <p>Have fun!
                </p>

                <ul>
                    <li><a href="resources/bitsandpizzas.zip">BitsAndPizzas</a></li>
                    <p>The &nbsp;<code>ic_add_white_24dp.png</code>, &nbsp;<code>restaurant.jpg</code>,
                        &nbsp;<code>ic_done_white_24dp.png</code>, &nbsp;<code>diavolo.jpg</code> and
                        &nbsp;<code>funghi.jpg</code>
                        &nbsp;images for the BitsAndPizzas app in chapters 8, 12 and 13.</p>

                    <li><a href="resources/catchat.zip">CatChat</a></li>
                    <p>The &nbsp;<code>kitten_small.jpg</code> image for the CatChat app in chapter 14</p>

                    <li><a href="resources/starbuzz.zip">StarBuzz</a></li>
                    <p>This includes the &nbsp;<code>starbuzz-logo.png</code>, &nbsp;<code>cappuccino.png</code>,
                        &nbsp;<code>filter.png</code>, and &nbsp;<code>latte.png</code> files mentioned
                        in the app in chapter 7.</p>

                    <li><a href="resources/aduck.zip">Duck</a></li>
                    <p>It's a duck. It's in chapter 5.</p>
                </ul>
            </div>
        );
    }
}

export default Resources;



// WEBPACK FOOTER //
// ./src/containers/Resources.js